import { style } from '@angular/animations';
import { getTreeNoValidDataSourceError } from '@angular/cdk/tree';
import {Component,OnInit,Input, SimpleChanges, OnChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import Exporting from "highcharts/modules/exporting";
Exporting(Highcharts);

@Component({
  selector: 'app-bubble-chart',
  templateUrl: './bubble-chart.component.html',
  styleUrls: ['./bubble-chart.component.css']
})
export class BubbleChartComponent implements OnInit, OnChanges {

  @Input() chartData: object;
  @Input() chartId;
  @Input() selectedlanguage;
  @Input() selectedDistrict;
  bubbleChart = Highcharts;
  chartOptions = {};
  @Input() yAxisPlot = [];
  chart: any;
  yAxisPlotHi=[];
  seriesdataHi=[];
  found:boolean;

  constructor() { }

  ngOnInit() {
    this.createBubbleChart(); 
    this.getTranslatedData();
    
 }

 ngOnChanges(changes: SimpleChanges): void {
    this.createBubbleChart();
    console.log('chartdataaaa',this.chartData);
    this.getTranslatedData();
    
 }
 getTranslatedData(){
  this.yAxisPlot.forEach(obj=>{
    console.log('obj=',obj);
  })

 }
 createBubbleChart(): any {
  // console.log('chartdataaaa',this.chartData);
  //   console.log('yaxis plot==',this.yAxisPlot);
    let selDist = this.selectedDistrict
  this.chartOptions = {
     exporting : {
        enabled: true
     },
     chart: {
      type: 'scatter',
      marginTop: 90,
      height:600
    },

    title: {
        text: this.chartData['title'],//this.selectedlanguage=='en'?this.chartData['title'] : "थीम डेटा",
        align: 'center'
    },

    xAxis: {
      categories: this.yAxisPlot,
      gridLineWidth: 1,
      labels: {
        formatter () {
          if(this.value == selDist){
            return `<span style="color:red">${this.value}</span>`
          }
          else
            return this.value
        }
      }
    },
    
    colors: ["#4d71a8", '#7ec0e0'],

    yAxis: {
        startOnTick: false,
        endOnTick: false,
        plotLines: [{
          label: { 
              text: 'Median (FY ' + this.chartData['curyear'] +')',//this.selectedlanguage=='en' ? 'Median (FY ' + this.chartData['curyear'] +')' : 'मेडियन (वित्तीय वर्ष ' + this.chartData['curyear'] + ')',  
              align: 'right', 
              style: {
                fontStyle: 'italic'
              },
            },
          color: '#2d323b', 
          dashStyle: 'dash', 
          value: this.chartData['median'], 
          width: 2    
        },
      ]
    },
    legend : {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'top',
      floating: true,
      y: 30,
      borderWidth: 1,
      shadow: true
    },  
    
    plotOptions : {
      scatter: {
        marker: {
          radius: 7
        },
        dataLabels: {
            enabled: true
        }
      },
    },

    series: this.chartData['seriesdata']
  };

  console.log(this.chartId);

  setTimeout(() => {

    if(this.chart){
      this.chart.destroy();
    }
    this.chart = this.bubbleChart.chart(this.chartId, this.chartOptions)        
  }, 0)
}

}
